import { gql } from "@apollo/client";

const GET_EXTRA_CREDIT_PRICE = gql`
  query GetExtraCreditPrice($currency: String) {
    extraCreditsPrice(currency: $currency) {
      id
      price
      active
    }
    me {
      paymentMethods {
        id
        default
      }
    }
  }
`;

export default GET_EXTRA_CREDIT_PRICE;
